import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si no tengo conocimiento de estimulación temprana?',
    a: 'El Megapack está diseñado para ser comprendido y aplicado por cualquier mamá, papá, abuelo o cuidador, sin importar si tenés o no formación previa. Todo está explicado en lenguaje claro, sin tecnicismos, con ejemplos concretos del contexto argentino. Muchos de nuestros compradores son papás primerizos que empezaron sin saber nada y hoy estimulan con sistema.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al completar tu pago recibís un email con el link de descarga en menos de 5 minutos. Son 6 archivos PDF de alta resolución que podés abrir desde tu celular, tablet, computadora o imprimir. Acceso de por vida desde cualquier dispositivo.'
  }, {
    q: '¿Está adaptado al contexto argentino?',
    a: 'Completamente. Todas las actividades usan materiales que se consiguen en Argentina, el lenguaje es rioplatense, los ejemplos son de nuestra cultura y los recursos mencionados (jardines, obras sociales, especialistas) corresponden al sistema argentino.'
  }, {
    q: '¿Funciona para niños con algún diagnóstico o retraso?',
    a: 'El material está diseñado para el desarrollo típico, pero muchas familias con niños con diagnóstico de TEA, retraso en el lenguaje u otras condiciones lo usan como complemento del trabajo terapéutico. Siempre recomendamos trabajar junto al equipo de salud del niño.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total. Si lo abrís, lo usás y no es lo que esperabas, te devolvemos el 100% del dinero sin preguntas, sin formularios y sin drama. Escribís a packcentral23@gmail.com y procesamos el reembolso en 48 horas.'
  }, {
    q: '¿Sirve también para docentes y profesionales?',
    a: 'Sí. Muchas de nuestras compradoras son maestras de nivel inicial, psicopedagogas, fonoaudiólogas y terapeutas que lo usan para planificar, orientar familias y complementar su práctica profesional con material listo en español argentino.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-sky-950" data-id="element-76">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-77">
        <h2 className="text-3xl font-extrabold text-center text-white mb-12" data-id="element-78">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-79">
          {faqs.map((faq, i) => <div key={i} className="border border-sky-800 rounded-2xl overflow-hidden bg-sky-900/60" data-id="element-80">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 hover:bg-sky-900/40 transition-colors" aria-expanded={openIndex === i} data-id="element-81">
                <span className="font-bold text-white pr-4" data-id="element-82">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-sky-300 transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-83" />
              </button>

              <AnimatePresence data-id="element-84">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-85">
                    <div className="px-6 pb-5 text-sky-100 leading-relaxed border-t border-sky-800 pt-3" data-id="element-86">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}